export default {"src":"/_next/static/media/procter.dd75051c.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};